export default __webpack_public_path__ + "static/media/locusofcontrol1Img5.2ff25ce2.png";